module.exports = __webpack_public_path__ + "img/tbi-no-cuffs.68248ba9.png";